import { inject,ModuleWithProviders, NgModule } from '@angular/core';

import { FUSE_CONFIG } from '@fuse/services/config.service';

@NgModule()
export class FuseModule {
    constructor() {
        const parentModule = inject(FuseModule, { optional: true, skipSelf: true });

        if (parentModule) {
            throw new Error('FuseModule is already loaded. Import it in the AppModule only!');
        }
    }

    static forRoot(config: any): ModuleWithProviders<FuseModule> {
        return {
            ngModule: FuseModule,
            providers: [
                {
                    provide: FUSE_CONFIG,
                    useValue: config
                }
            ]
        };
    }
}
